var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AfterViewInit, EventEmitter, NgZone, OnDestroy } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { Settings } from '../../core/config/settings.service';
import { LazyLoaderService } from '../../core/utils/lazy-loader.service';
import { CurrentUser } from '../../auth/current-user';
import { Subscriptions } from '../../shared/billing/subscriptions.service';
import { Toast } from '../../core/ui/toast.service';
var CreditCardFormComponent = /** @class */ (function () {
    /**
     * CreditCardFormComponent Constructor.
     */
    function CreditCardFormComponent(subscriptions, currentUser, settings, zone, lazyLoader, toast) {
        this.subscriptions = subscriptions;
        this.currentUser = currentUser;
        this.settings = settings;
        this.zone = zone;
        this.lazyLoader = lazyLoader;
        this.toast = toast;
        /**
         * Event fired when form is submitted and card is added successfully on active gateway.
         */
        this.created = new EventEmitter();
        /**
         * Display text for form submit button.
         */
        this.submitButtonText = 'Submit';
        /**
         * Whether form submit button should be shown.
         */
        this.showSubmitButton = true;
        /**
         * Whether order summary should be shown in the template.
         */
        this.showOrderSummary = false;
        /**
         * Whether backend request is in progress.
         */
        this.loading = false;
        /**
         * Mounted stripe elements.
         */
        this.stripeElements = [];
        this.resetForm();
    }
    CreditCardFormComponent.prototype.ngAfterViewInit = function () {
        this.initStripe();
    };
    CreditCardFormComponent.prototype.ngOnDestroy = function () {
        this.destroyStripe();
    };
    /**
     * Submit stripe elements credit card form.
     */
    CreditCardFormComponent.prototype.submitForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, token, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // prevent all subscriptions on demo site.
                        if (this.settings.get('common.site.demo')) {
                            return [2 /*return*/, this.toast.open('You can\'t do that on demo site.')];
                        }
                        this.loading = true;
                        return [4 /*yield*/, this.stripe.createToken(this.stripeElements[0])];
                    case 1:
                        _a = _b.sent(), token = _a.token, error = _a.error;
                        if (error) {
                            this.error = error.message;
                            this.loading = false;
                        }
                        else {
                            this.addCardToUser(token);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CreditCardFormComponent.prototype.addCardToUser = function (stripeToken) {
        var _this = this;
        this.loading = true;
        this.subscriptions.addCard(stripeToken.id)
            .pipe(finalize(function () { return _this.loading = false; }))
            .subscribe(function (response) {
            _this.resetForm();
            _this.currentUser.assignCurrent(response.user);
            _this.created.emit(response.user);
        }, function (response) {
            _this.error = response.messages.general;
        });
    };
    /**
     * Initiate stripe elements credit card form.
     */
    CreditCardFormComponent.prototype.initStripe = function () {
        var _this = this;
        this.lazyLoader.loadScript('https://js.stripe.com/v3').then(function () {
            var fields = ['cardNumber', 'cardExpiry', 'cardCvc'];
            _this.stripe = Stripe(_this.settings.get('billing.stripe_public_key'));
            var elements = _this.stripe.elements();
            fields.forEach(function (field) {
                var el = elements.create(field, { classes: { base: 'base' } });
                el.mount('#' + field);
                el.on('change', _this.onChange.bind(_this));
                _this.stripeElements.push(el);
            });
        });
    };
    /**
     * Destroy all stripe elements instances.
     */
    CreditCardFormComponent.prototype.destroyStripe = function () {
        this.stripeElements.forEach(function (el) {
            el.unmount();
            el.destroy();
        });
    };
    /**
     * Fired on stripe element "change" event.
     */
    CreditCardFormComponent.prototype.onChange = function (change) {
        var _this = this;
        this.zone.run(function () {
            _this.error = change.error ? change.error.message : null;
        });
    };
    /**
     * Reset credit card form.
     */
    CreditCardFormComponent.prototype.resetForm = function () {
        this.error = null;
    };
    return CreditCardFormComponent;
}());
export { CreditCardFormComponent };
